module.exports = __webpack_public_path__ + "static/media/Add_Coupon_Icon.5f953649.png";